<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>
      {{ 'TPL_HANTERAARBETSORDRAR_HEADER' | translate }}
      @if (arbetsorders) {
        <span class="small-text">{{ nrOfSelectedAos }} av {{ arbetsorders.length }}
        valda</span>
      }
    </rask-header>
  </ng-container>

  @if (arbetsorders) {
    <div class="info-container">
      <rask-menu-button alignment="left" [template]="tpl" #menu>
      </rask-menu-button>
      <ng-template #tpl>
        <div class="menu-btn-container">
          <rask-action-button
            class="col-12"
            icon="fas fa-sync-alt"
            aid="uppdaterafranregelverk"
            (click)="uppdateraVirkesordrar()"
            [disabled]="!updateEnabled">
            Uppdatera från regelverk
          </rask-action-button>
          <rask-action-button
            class="col-12"
            icon="fas fa-sync-alt"
            aid="uppdateradestineringsalternativ"
            (click)="updateDestineringsalternativ()"
            [disabled]="!updateEnabled">
            Uppdatera destineringsalternativ
          </rask-action-button>
          <rask-action-button
            class="col-12"
            icon="fas fa-plus"
            [disabled]="!canEditManuellaDestineringsalternativ"
            (click)="addDestineringsalternativ()"
            infoText="Välj ett (1) handelssortiment och ett (1) produktionsområde för att kunna lägga till destineringsalternativ"
            aid="button-destineringsalternativ-manuella">
            Lägg till destineringsalternativ
          </rask-action-button>
        </div>
      </ng-template>
      <rask-checkbox [(ngModel)]="allSelected" text="{{ 'TPL_LIST_SELECT_ALL' | translate }}"
      (checkedChange)="onAllSelectedChanged($event)" class="allCheckBox low"></rask-checkbox>
    </div>
  }

  <div>
    <div class="list-container">
      @for (arbetsorder of arbetsorders; track arbetsorder) {
        <div>
          <div class="row row-border"
                    [ngClass]="{
                        'red-back' : arbetsorder.warnings.length > 0,
                        'ao-row-hover' : arbetsorder.isHover
                    }"
            (mouseover)="mouseOver(arbetsorder.id)"
            (mouseout)="mouseOut(arbetsorder.id)">
            <div class="col-10">
              <div class="dot"></div>
              <a href="" (click)="aoDetails($event, arbetsorder.id)">
                {{ arbetsorder.beteckning }} {{ arbetsorder.namn }}
              </a>
              @for (warning of arbetsorder?.warnings; track warning) {
                <span class="icon">
                  <i class="fal"
                    [ngClass]="{'info fa-info-circle': warning.type === 'info', 'warning fa-exclamation-square': warning.type === 'warning', 'error fa-exclamation-circle':  warning.type === 'error' }"
                    placement="bottom"
                    [ngbTooltip]="warning.brief">
                  </i>
                </span>
              }
            </div>
            <div class="col-2">
              <rask-checkbox (checkedChange)="onCheckedChanged($event)" class="checkbox low"
              [(ngModel)]="arbetsorder.selected"></rask-checkbox>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <ng-container footer></ng-container>
</rask-container-block>